<template>
  <div>
    <v-card elevation="0" height="2vh">
      <v-card-text>
        <v-row>
          <v-col class="user-info-space">
            <v-row no-gutters>
              <v-col cols="1" :class="iconMarginClass">
                <v-icon class="main-icon" color="white">mdi-account</v-icon>
              </v-col>
              <v-col cols="11" class="mt-n2 pr-2">
                <v-row class="mr-1">
                  <v-col cols="12">
                    <span class="user-text">{{ user }}</span>
                  </v-col>
                  <v-col cols="12" class="mt-n5">
                    <span class="date-text">{{ date }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="note-main text-info-space">
            <v-row class="">
              <v-col cols="12" class="mt-n1">
                <span class="">{{ note }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  export default {
    props: {
      user: {
        type: String,
        require: true,
        default: '',
      },
      date: {
        type: String,
        require: true,
        default: '',
      },
      note: {
        type: String,
        require: true,
        default: '',
      },
      iconMarginClass: {
        type: String,
        require: false,
        default: '',
      },
    },
  };
</script>
<style scoped>
  .user-info-space {
    width: 20% !important;
    max-width: 20% !important;
    min-width: 20% !important;
  }
  .text-info-space {
    width: 80% !important;
    max-width: 80% !important;
    min-width: 80% !important;
  }
  .main-icon {
    background: var(--dark-color);
    padding: 4px !important;
    border-radius: 50% !important;
  }
  .note-main {
    background: var(--background-color) !important;
    height: 6.5vh !important;
    border-radius: 12px !important;
    overflow-y: auto !important;
    margin-top: 1vh !important;
  }
  .user-text {
    font-size: 12px;
    color: #212121;
  }
  .date-text {
    font-size: 11px;
    color: #212121;
  }
</style>
